import { MarketingArticle } from '../components/marketing/MarketingArticle';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { SignUpButton, TalkToFoundersButton } from '../components/CTAButtons';
import { WHAT_IS_INDUCE_BREADCRUMB } from '../content/breadcrumbs';
import { WHAT_IS_INDUCE_CONTENT } from '../content/whatIsInduce';
import { PageSeo } from '../components/seo/PageSeo';
import { buildMarketingPageSchema } from '../lib/schema';
import { WHAT_IS_INDUCE_META } from '../lib/seo';

export function WhatIsInducePage() {
  return (
    <>
      <PageSeo meta={WHAT_IS_INDUCE_META} />
      <JsonLd
        data={buildMarketingPageSchema(
          WHAT_IS_INDUCE_CONTENT.title,
          WHAT_IS_INDUCE_META.path,
          WHAT_IS_INDUCE_META.description,
          { breadcrumbs: WHAT_IS_INDUCE_BREADCRUMB },
        )}
      />
      <MarketingLandingShell>
        <MarketingArticle
          title={WHAT_IS_INDUCE_CONTENT.title}
          lede={WHAT_IS_INDUCE_CONTENT.lede}
          sections={[...WHAT_IS_INDUCE_CONTENT.sections]}
          relatedLinks={[
            { label: 'Induce vs Runway', to: '/vs/runway' },
            { label: 'Induce vs Higgsfield', to: '/vs/higgsfield' },
            { label: 'Induce vs LTX Studio', to: '/vs/ltx-studio' },
            { label: 'Induce vs Synthesia', to: '/vs/synthesia' },
          ]}
        >
          <SignUpButton variant="primary" />
          <TalkToFoundersButton variant="ghost" />
        </MarketingArticle>
      </MarketingLandingShell>
    </>
  );
}
